"use client"

import { useRef, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ExternalLink } from "lucide-react"

const FeaturedShorts = ({ shorts = [], youtubeLink = "" }) => {  // Add youtubeLink prop
  const scrollContainerRef = useRef(null);
  const [channelId, setChannelId] = useState("@VillaKosh");


  const handleSubscribe = () => {
    window.open(`https://www.youtube.com/${channelId}?sub_confirmation=1`, "_blank")
  }

  const handleWatchTour = () => {
    if (youtubeLink) {
      window.open(youtubeLink, "_blank")
    }
  }

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg mb-8">
      <h3 className="text-[20px] font-bold mb-6">Featured Villa Shorts</h3>

      <div className="relative">
        {/* Scrollable Container */}
        <div 
          ref={scrollContainerRef}
          className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth"
          style={{ scrollSnapType: 'x mandatory' }}
        >
          {shorts.map((shortId, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-[300px] relative rounded-lg overflow-hidden shadow-md bg-black"
              style={{ scrollSnapAlign: 'start' }}
            >
              <div className="aspect-[9/16] w-full">
                <iframe
                  className="w-full h-full"
                  src={`https://www.youtube.com/embed/${shortId}?autoplay=0&mute=1&controls=1&loop=1&rel=0`}
                  title={`Villa Short ${index + 1}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                <a
                  href={`https://www.youtube.com/shorts/${shortId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-white text-black px-3 py-1.5 rounded-full text-sm font-medium hover:bg-gray-100 transition-colors"
                >
                  <span>Watch on YouTube</span>
                  <ExternalLink className="w-3.5 h-3.5" />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Update the buttons section */}
        <div className="mt-4 text-center space-y-3">
          {youtubeLink && (
            <button
              onClick={handleWatchTour}
              className="w-full bg-red-500 text-white px-4 py-3 rounded-lg text-sm font-medium hover:bg-red-700 transition-colors md:hidden mb-2"
            >
              Watch Villa Tour
            </button>
          )}
        </div>
      </div>
    </div>
  )
}


export default FeaturedShorts;